import React from 'react';
import { StyledFormContainer, StyledPaperContainer, StyledSectionSubtitle, StyledSectionTitle } from '../../PlusWebsiteEditor.styles';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { RadioGroupProps } from '@material-ui/core/RadioGroup';
import { OnboardingJourney, WebsiteConfiguration } from '../../types/websiteConfiguration';

type Props = {
  onboardingJourney: WebsiteConfiguration['onboarding_journey'];
  onChange: (e: React.ChangeEvent<RadioGroupProps>) => void;
  postalPharmaciesCount?: number;
};

const getSubtitle = (postalPharmaciesCount?: number) => {
  if (typeof postalPharmaciesCount !== 'number') {
    return 'Could not fetch postal pharmacies count for this organisation';
  }

  if (postalPharmaciesCount === 0) {
    return 'This organisation does not have an active postal pharmacy';
  }

  if (postalPharmaciesCount > 0) {
    return `This organisation has ${postalPharmaciesCount} active postal ${postalPharmaciesCount === 1 ? 'pharmacy' : 'pharmacies'}`;
  }
};

const OnboardingSection = ({ onboardingJourney, postalPharmaciesCount, onChange }: Props) => (
  <StyledPaperContainer>
    <StyledSectionTitle>Onboarding Journey</StyledSectionTitle>
    <StyledSectionSubtitle>{getSubtitle(postalPharmaciesCount)}</StyledSectionSubtitle>
    <StyledFormContainer>
      <RadioGroup aria-label="payment" name="onboarding_journey" onChange={onChange} value={onboardingJourney}>
        <FormControlLabel disabled={postalPharmaciesCount === 0} value={OnboardingJourney.DELIVERY_COLLECTION} control={<Radio />} label="Delivery (commissionable) / Collection" />
        <FormControlLabel disabled={postalPharmaciesCount === 0} value={OnboardingJourney.PHARMACY_SELECT} control={<Radio />} label="Just Select Pharmacy" />
        <FormControlLabel value={OnboardingJourney.MARKETPLACE} control={<Radio />} label="Marketplace Delivery Options" />
      </RadioGroup>
    </StyledFormContainer>
  </StyledPaperContainer>
);

export default OnboardingSection;
